import { mapActions, mapGetters, mapMutations } from 'vuex'
import PadLockIcon from '@/assets/padlock.svg'
import DocumentIcon from '@/assets/document.svg'
import LogoutIcon from '@/assets/logout.svg'
import SyncIcon from '@/assets/sync.svg'

import MainButton from '@/components/MainButton/index'
import PlainTextField from '@/components/PlainTextField/index'
import Alert from '@/components/Alert/index'
import ResponseDialog from '@/components/ResponseDialog/index'

export default {
  name: 'settings',
  components: {
    MainButton,
    Alert,
    PlainTextField,
    ResponseDialog
  },
  data: () => ({
    roundForm: false,
    roundNumber: '',
    PadLockIcon,
    DocumentIcon,
    LogoutIcon,
    SyncIcon,
    offshorlyLogo: require('@/assets/offshorly-logo.png'),
    roundNumberRules: [
      v => !!v || 'Round number is required',
      v => /^[0-9]*$/.test(v) || 'Only numbers are allowed.'
    ],
    deleteAccountDialog: false,
    deleteAccountPassword: null,
    deleteAccountResponseDialog: false,
    deleteAccountResponseDialogText: ''
  }),
  computed: {
    ...mapGetters('admin', {
      manualSyncSuccess: 'MANUAL_SYNC_RESPONSE',
      manualSyncLoader: 'MANUAL_SYNC_RESPONSE_LOADER',
      lastSyncDate: 'LAST_SYNC_DATE',
      userTotal: 'USER_TOTAL'
    }),
    ...mapGetters('auth', {
      isAdmin: 'IS_ADMIN'
    }),
    ...mapGetters('auth', {
      userObj: 'USER_OBJ'
    }),
    ...mapGetters('player', {
      deletePlayerLoading: 'GET_DELETE_PLAYER_LOADING',
      deletePlayerResponse: 'DELETE_PLAYER_REPSONSE'
    })
  },
  methods: {
    ...mapActions({
      toggleHasMaxWidthAction: 'TOGGLE_HAS_MAX_WIDTH'
    }),
    ...mapActions('admin', {
      syncFootballData: 'SYNC_FOOTBALL_DATA',
      fetchLastSyncDateAction: 'FETCH_LAST_SYNC_DATE',
      fetchUserTotalAction: 'FETCH_USER_TOTAL',
      syncRound: 'SYNC_ROUND_NUMBER'
    }),
    ...mapMutations('admin', {
      setSyncSuccess: 'SET_MANUAL_SYNC_RESPONSE',
      setSyncRoundSuccess: 'SET_SYNC_ROUND_NUMBER'
    }),
    ...mapActions('player', {
      deletePlayer: 'DELETE_PLAYER'
    }),
    logout(e) {
      if (e) {
        e.preventDefault()
      }

      localStorage.clear()
      this.$router.push({ path: '/login' })
    },
    deleteAccount() {
      this.deleteAccountDialog = true
    },
    sync(e) {
      e.preventDefault()
      this.syncFootballData().then(() => {
        setTimeout(() => {
          this.setSyncSuccess(false)
        }, 4000)
      })
    },
    submitRoundSync() {
      if (this.$refs.roundForm.validate()) {
        const payload = {
          roundNumber: this.roundNumber
        }
        this.syncRound(payload).then(() => {
          setTimeout(() => {
            this.setSyncSuccess(false)
          }, 4000)
        })
      }
    },
    showOnlyWhenRegular() {
      return !this.isAdmin
    },
    showOnlyWhenAdmin() {
      return this.isAdmin
    },
    deleteAccountDialogCancel() {
      this.deleteAccountPassword = null
      this.deleteAccountDialog = false
    },
    deleteAccountDialogConfirm() {
      const payload = {
        userId: this.userObj.id,
        password: this.deleteAccountPassword
      }
      this.deletePlayer(payload)
    },
    deleteAccountResponseDialogButtonClick() {
      if (this.deletePlayerResponse.success) {
        this.logout()
      } else {
        this.deleteAccountResponseDialog = false
      }
    }
  },
  activated() {
    this.$store.commit('SET_PAGE_TITLE', 'settings')
    this.$store.commit('SET_HEADER_TABS', null)
    this.toggleHasMaxWidthAction(false)
    if (this.isAdmin) {
      this.fetchLastSyncDateAction()
      this.fetchUserTotalAction()
    }
  },
  deactivated() {
    this.toggleHasMaxWidthAction(true)
  },
  watch: {
    deletePlayerResponse() {
      this.deleteAccountResponseDialog = true
      this.deleteAccountResponseDialogText = this.deletePlayerResponse.message
    }
  }
}
